// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3khGg","largestCol":"styles_largestCol__1imn1","smallestCol":"styles_smallestCol__3X6TM"};